<ng-select
  class="custom"
  [(ngModel)]="value"
  [items]="dropDownItems"
  bindLabel="name"
  [multiple]="false"
  placeholder="{{ placeholderTranslationString | translate }}"
  [disabled]="disabled">
</ng-select>
